import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { RawUserData } from "../profile.types";

type FetchUserProfileResponse = {
  user_data: RawUserData;
};

type Args = {
  enabled?: boolean;
};

export function useFetchUserProfile({ enabled = true }: Args = {}) {
  return useQuery<FetchUserProfileResponse>({
    queryKey: ["user-profile"],
    queryFn: () => apiRequest("/profile/", "GET"),
    enabled,
  });
}
